import React from 'react';
import { Link } from 'react-router-dom';
import { UserMinus } from 'lucide-react';
import { pintarDia } from '../lib/horaEspana';
import { nombreDePlan } from '../lib/labels';
import { enlaceDeLaFicha } from '../lib/gestorDeClientes';

// QUIÉN HA PEDIDO LA BAJA EN LOS ÚLTIMOS 10 DÍAS (Francisco, 21-10). Estaba en el Dashboard;
// desde que se apagó (PR 9 de Enrique, 21-10) va en Clientes, pestaña Gestión de
// suscripciones. La regla (qué es pedirla y la ventana en días de España) es del servidor
// (`backend/core/bajas_pedidas.py`, `GET /admin/bajas-pedidas`); aquí solo se pinta, la más
// reciente arriba como llega.
const BajasPedidas = ({ bajas, catalogo }) => (
    <section className="rounded-xl border border-[#F3C9C9] bg-[#FDF3F3] p-3 sm:p-4" data-testid="bajas-pedidas">
        <h2 className="text-[11px] uppercase tracking-wider font-bold text-[#B91C1C] flex items-center gap-2 mb-2">
            <UserMinus className="w-3.5 h-3.5" />
            Han pedido la baja (últimos 10 días)
        </h2>
        {bajas.length === 0 ? (
            <p className="text-[#57544E] text-sm" data-testid="bajas-pedidas-vacio">
                Nadie ha pedido la baja en los últimos 10 días
            </p>
        ) : (
            <ul className="divide-y divide-[#F3C9C9]">
                {bajas.map((b) => (
                    <li key={b.client_id} data-testid={`baja-pedida-${b.client_id}`}>
                        <Link to={enlaceDeLaFicha(b.client_id)}
                            className="flex items-center justify-between gap-3 py-2 hover:bg-white/60 rounded-lg px-1 -mx-1">
                            <span className="min-w-0">
                                <span className="block text-[#1C1B19] text-sm font-semibold truncate">{b.nombre}</span>
                                <span className="block text-[#57544E] text-xs">
                                    La pidió el {pintarDia(b.dia, { day: 'numeric', month: 'short' }, '-')}
                                    {b.acceso_hasta && (
                                        <span className="block sm:inline">
                                            <span className="hidden sm:inline"> · </span>
                                            Acceso hasta el {pintarDia(b.acceso_hasta, { day: 'numeric', month: 'short', year: 'numeric' }, '-')}
                                        </span>
                                    )}
                                </span>
                            </span>
                            <span className="flex-shrink-0 text-xs text-[#57544E] whitespace-nowrap">
                                {b.plan ? nombreDePlan(b.plan, catalogo) : ''}
                            </span>
                        </Link>
                    </li>
                ))}
            </ul>
        )}
    </section>
);

export default BajasPedidas;
